import "./Header.css";
import React from "react";
import Logo from "./Logo";
import HeaderControls from "./HeaderControls";
import useClubs from "../../hooks/useClubs";

const Header = React.memo(({ SearchFilterData }) => {
  const clubs = useClubs(SearchFilterData);
  
  return (
    <div className="header-container">
      <div className="header">
        <Logo />
        <HeaderControls clubs={clubs} />
      </div>
    </div>
  );
});

Header.displayName = 'Header';

export default Header;
